$(() => {
  const $wrap = $('.aiot-block .type-list'); //圆
  const $items = $wrap.find('.type-item'); //每个元素
  const length = $items.length; //元素个数
  const size = $wrap.width(); //圆的尺寸
  console.log('size', size)
  const radius = size / 2; //圆的半径
  const sRotate = Math.PI * 2 / length; //每一个叠加旋转的角度
  //如果有偶数个 第一个旋转角度 sRotate*-0.5 否则 第一个就旋转角度
  const sp = length % 2 === 0 ? (sRotate * -0.5) : 0;
  $items.each(function () {
    const $t = $(this);
    const index = $t.attr('data-index') * 1;
    const rotate = sp + (index - 1) * sRotate; //旋转的角度
    const x = Math.sin(rotate) * radius; //和圆心之间的距离---X方向
    const y = Math.cos(rotate) * radius; //和圆心之间的距离---Y方向
    const left = radius + x;
    const top = radius - y;
    $t.css({ left, top });
  });
});
